import { Injectable } from "@angular/core";
import { GenericResponse } from '../business-entities/generic-response';
import { GearBoxModel, CooGroupModel, FilterDataModel, MaintenanceWorkModel, PartViewModel } from '../business-entities/tecrmi-model';
import { TecRMIDataService } from '../data-services/Tec-RMI-data.service';

@Injectable({
    providedIn: 'root'
})

export class TecRMIBusinessService {
    constructor(private tecrmiDataService: TecRMIDataService) {
    }
    
    async checkVehicleHasServiceProposal(tecDocType: number) {
        return this.tecrmiDataService.checkVehicleHasServiceProposal(tecDocType);
    }
    async getGearBoxList(tecDocType : number): Promise<GenericResponse<Array<GearBoxModel>>> {
        return this.tecrmiDataService.getGearBoxList(tecDocType);
    }

    async getCooGroupList(model: any): Promise<GenericResponse<Array<CooGroupModel>>> {
        return this.tecrmiDataService.getCooGroupList(model);
    }

    async getVehicleServiceProposal(model: FilterDataModel): Promise<GenericResponse<any>> {
        return this.tecrmiDataService.getVehicleServiceProposal(model);
    }

    async getVehicleMaintenanceWorkList(tecDocType: number): Promise<GenericResponse<MaintenanceWorkModel>> {
        return this.tecrmiDataService.getVehicleMaintenanceWorkList(tecDocType);
    }

    async getPartsForWork(tecDocType:number , workStepId :number ) : Promise<GenericResponse<Array<PartViewModel>>>{
        return this.tecrmiDataService.getPartsForWork(tecDocType,workStepId);
    }
    
    async updateTecDocIds(lpNumber:any) : Promise<string>{
        return this.tecrmiDataService.updateTecDocIds(lpNumber);
    }

    async getAvailableStock(viewmodel:any) : Promise<any>{
        return this.tecrmiDataService.getAvailableStock(viewmodel);
    }

    async createArticlePurchaseOrder(viewmodel:any) : Promise<any>{
        return this.tecrmiDataService.createArticlePurchaseOrder(viewmodel);
    }

    async getLabourWorkList(tecDocType : number): Promise<GenericResponse<Array<any>>> {
        return this.tecrmiDataService.getLabourWorkList(tecDocType);
    }

    async getWorkStepsByItemMpId(tecDocType: number,korId: number,itemMpId: number): Promise<GenericResponse<Array<any>>> {
        return this.tecrmiDataService.getWorkStepsByItemMpId(tecDocType,korId,itemMpId);
    }

}